import { type ReactNode, createContext, useContext } from 'react'

export type OpenCreateProjectOptions = {
  folderId?: string | null
}

type AppShellContextValue = {
  openCreateProject: (opts?: OpenCreateProjectOptions) => void
  closeMobileSidebar: () => void
}

const AppShellContext = createContext<AppShellContextValue | null>(null)

export function AppShellProvider({
  value,
  children,
}: {
  value: AppShellContextValue
  children: ReactNode
}) {
  return <AppShellContext.Provider value={value}>{children}</AppShellContext.Provider>
}

export function useAppShell(): AppShellContextValue {
  const ctx = useContext(AppShellContext)
  if (!ctx) {
    throw new Error('useAppShell must be used within AppShell')
  }
  return ctx
}
